import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide7 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={6}
      total={total}
      label="Tax Intelligence"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(730px 560px at 74% 35%,rgba(216,182,46,.22),transparent 68%),linear-gradient(115deg,#020303,#060f0b,#020202)"
      }}
    >

      <h2>{t.title}</h2>
      
      <p className="lead">{t.body}</p>

      <div className="grid four wide">
        <div className="card">
          <span className="num">01</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">02</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">03</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
        <div className="card">
          <span className="num">04</span>
          <h3>{t.c4Title}</h3>
          <p>{t.c4Body}</p>
        </div>
      </div>
    </SlideShell>
  );
};


